<template lang="pug">
modal#signature-created-modal(
  :close-button-label='$t("modal.signatureCreated.closeButtonLabel")'
  :process-button-label='$t("modal.signatureCreated.processButtonLabel")'
  :title='$t("modal.signatureCreated.title")'
  @process='$emit("process")'
  ref='modal'
)
  p.m-0 {{ $t('modal.signatureCreated.successMessage') }}
  p.m-0(v-html='$t("modal.signatureCreated.createRubricaMessage")')
  p.m-0 {{ $t('modal.signatureCreated.promptMessage') }}
  .mt-2.text-center
    img.img-fluid(src='/img/ilustrations/signature-feedback.svg')
</template>
<script>
import Modal from '@/ui/molecules/Modal.vue';

export default {
  components: {
    Modal,
  },
};
</script>
